/**
 * Handheld Procore sessions keep clipping outlines on the GPU path drag already
 * uses. CPU outline rebuilds were measured at ~90 ms on release and ~13 ms per
 * idle frame.
 *
 * Standalone keeps the CPU path. GPU outlines often disappear in ortho, which
 * standalone exposes and Procore does not, so gating on Procore (plus
 * `isMobile`) avoids a broken sectioning view on phones and iPads in the
 * classic/new UX. Outline object picking only reads the CPU buffers; see
 * {@link clippingOutlineObjectsArePickable}.
 */
export function clippingOutlinesAreGpuComputed(isMobile: boolean, isProcoreDesign: boolean): boolean {
    return isMobile && isProcoreDesign;
}

/**
 * Whether `view.getOutlineObjectsOnScreen()` can answer. It reads the CPU outline
 * buffers, which Procore handhelds no longer build, so the standalone Outline
 * Laser still groups clipped files there. Callers check this rather than treating
 * the empty result as "nothing is clipped".
 */
export function clippingOutlineObjectsArePickable(isMobile: boolean, isProcoreDesign: boolean): boolean {
    return !clippingOutlinesAreGpuComputed(isMobile, isProcoreDesign);
}

/**
 * Interiors of cut walls stay visible. `triangles.doubleSided` only disables
 * `CULL_FACE` on the same draw — it is not extra geometry and does not move the
 * primitive or GPU-byte budgets — so handhelds keep the desktop behaviour.
 */
export function clippingTrianglesAreDoubleSided(hasClippingPlanes: boolean): boolean {
    return hasClippingPlanes;
}
